import React from "react";
import PropTypes from "prop-types";
import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    currentDevice: state.rootReducer.currentDevice || "xl",
    settings: state?.rootReducer?.appearanceSettings || {},
  };
};

class Subscribe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  shouldComponentUpdate(nextProp, nextState) {
    const currentPayload = this.props?.payload;
    const nextPayload = nextProp?.payload;

    // console.log(JSON.stringify(currentPayload) === JSON.stringify(nextPayload));
    if (
      !isEqual(currentPayload, nextPayload) ||
      !isEqual(nextProp.settings, this.props.settings)
    ) {
      return true;
    }
    // console.log("re-render");
    return false;
  }

  _initSubscribe = () => {
    const buttonSettings = this.props.settings && this.props.settings["Button"];
    let { payload } = this.props;
    const fontFamily = this.props.settings["body_font"]?.fontFamily;

    if (payload === null) payload = this.props.options.payload;

    const { newsletterSettings: datasnewsletterSettings = {} } =
      payload && payload.datas;
    const {
      newsletterSettings: settingsnewsletterSettings = {},
      viewSettings = {},
    } =
      payload &&
      (payload["settings-" + this.props.currentDevice] || payload.settings);
    const newsletterSettings = {
      ...datasnewsletterSettings,
      ...settingsnewsletterSettings,
      buttonIconPosition: datasnewsletterSettings?.buttonIconPosition,
    };

    const cssSettings = generateStyle(payload, "container");
    const cssAlignment = generateStyle(payload, "alignment");

    const buttonCSS = {
      backgroundColor:
        newsletterSettings.btnBackground || buttonSettings?.bgColor || null,
      color: newsletterSettings.btnColor || buttonSettings?.color || null,
      fontFamily: newsletterSettings.btnFontFamily || null,
      fontWeight: newsletterSettings.btnFontWeight || null,
      fontSize: newsletterSettings.btnFontSize || buttonSettings?.size || null,
      fontStyle: newsletterSettings.btnFontStyle || null,
      letterSpacing: newsletterSettings.btnLetterSpacing || null,
      borderRadius:
        ((newsletterSettings.btnBorderRadius &&
          newsletterSettings.btnBorderRadius["lt"]) ||
          6) +
        "px " +
        ((newsletterSettings.btnBorderRadius &&
          newsletterSettings.btnBorderRadius["rt"]) ||
          6) +
        "px " +
        ((newsletterSettings.btnBorderRadius &&
          newsletterSettings.btnBorderRadius["rb"]) ||
          6) +
        "px " +
        ((newsletterSettings.btnBorderRadius &&
          newsletterSettings.btnBorderRadius["lb"]) ||
          6) +
        "px",
    };

    if (newsletterSettings && newsletterSettings.btnBorderTarget) {
      buttonCSS[newsletterSettings.btnBorderTarget + "Style"] =
        newsletterSettings.btnBorderStyle || null;
      buttonCSS[newsletterSettings.btnBorderTarget + "Color"] =
        newsletterSettings.btnBorderColor || null;
      buttonCSS[newsletterSettings.btnBorderTarget + "Width"] =
        newsletterSettings.btnBorderWidth || null;
    }

    const fieldCSS = {
      backgroundColor: newsletterSettings.flBackground || null,
      color: newsletterSettings.flColor || null,
      textAlign: newsletterSettings.flTextAlign || null,
      fontFamily: newsletterSettings.flFontFamily || fontFamily || null,
      fontWeight: newsletterSettings.flFontWeight || null,
      fontSize: newsletterSettings.flFontSize || null,
      fontStyle: newsletterSettings.flFontStyle || null,
      letterSpacing: newsletterSettings.flLetterSpacing || null,
      borderRadius:
        ((newsletterSettings.flBorderRadius &&
          newsletterSettings.flBorderRadius["lt"]) ||
          0) +
        "px " +
        ((newsletterSettings.flBorderRadius &&
          newsletterSettings.flBorderRadius["rt"]) ||
          0) +
        "px " +
        ((newsletterSettings.flBorderRadius &&
          newsletterSettings.flBorderRadius["rb"]) ||
          0) +
        "px " +
        ((newsletterSettings.flBorderRadius &&
          newsletterSettings.flBorderRadius["lb"]) ||
          0) +
        "px",
    };

    if (newsletterSettings && newsletterSettings.flBorderTarget) {
      fieldCSS[newsletterSettings.flBorderTarget + "Style"] =
        newsletterSettings.flBorderStyle || null;
      fieldCSS[newsletterSettings.flBorderTarget + "Color"] =
        newsletterSettings.flBorderColor || null;
      fieldCSS[newsletterSettings.flBorderTarget + "Width"] =
        newsletterSettings.flBorderWidth || null;
    }

    const boxCss = {};

    if (!viewSettings.hasOwnProperty("showInline")) {
      viewSettings.showInline = true;
    }

    if (viewSettings.showInline) {
      boxCss.marginRight = viewSettings.marginInBetween || 10;
    } else {
      boxCss.marginBottom = viewSettings.marginInBetween || 10;
    }

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div
              className={`newsletter-box ${this.props.currentDevice}-screen`}
              style={cssAlignment}
            >
              <div className="overlay"></div>
              <div
                style={{
                  display: "flex",
                  flexDirection: viewSettings.showInline ? "row" : "column",
                  width: "100%",
                  // width: viewSettings.showInline ==="row"?"60%":"100%",
                }}
              >
                <span
                  className="newsletter-field"
                  style={{ display: "block", ...boxCss }}
                >
                  <input
                    type="text"
                    name="newsletter"
                    placeholder={
                      newsletterSettings[
                        "flPlaceholder_" + this.props.currentLang
                      ]
                    }
                    className="input-text newsletter-input subscribe-email"
                    style={fieldCSS}
                  />
                </span>
                <span
                  className="newsletter-btn btn-subscribe"
                  style={buttonCSS}
                >
                  <span>
                    {newsletterSettings.useButtonIcon &&
                      newsletterSettings.buttonIconPosition !== "right" &&
                      newsletterSettings.buttonIconClass &&
                      Array.isArray(newsletterSettings.buttonIconClass) && (
                        <span className="left">
                          <FontAwesomeIcon
                            icon={[
                              newsletterSettings.buttonIconClass[0],
                              newsletterSettings.buttonIconClass[1],
                            ]}
                          />
                        </span>
                      )}
                    {newsletterSettings.useButtonIcon &&
                      newsletterSettings.buttonIconPosition !== "right" &&
                      newsletterSettings.buttonIconClass &&
                      !Array.isArray(newsletterSettings.buttonIconClass) && (
                        <span className="left">
                          <FontAwesomeIcon
                            icon={[
                              "fas",
                              newsletterSettings.buttonIconClass.replace(
                                "fa-",
                                ""
                              ),
                            ]}
                          />
                        </span>
                      )}

                    {newsletterSettings["btnLabel_" + this.props.currentLang]}

                    {newsletterSettings.useButtonIcon &&
                      newsletterSettings.buttonIconPosition === "right" &&
                      newsletterSettings.buttonIconClass &&
                      Array.isArray(newsletterSettings.buttonIconClass) && (
                        <span className="right">
                          <FontAwesomeIcon
                            icon={[
                              newsletterSettings.buttonIconClass[0],
                              newsletterSettings.buttonIconClass[1],
                            ]}
                          />
                        </span>
                      )}
                    {newsletterSettings.useButtonIcon &&
                      newsletterSettings.buttonIconPosition === "right" &&
                      newsletterSettings.buttonIconClass &&
                      !Array.isArray(newsletterSettings.buttonIconClass) && (
                        <span className="right">
                          <FontAwesomeIcon
                            icon={[
                              "fas",
                              newsletterSettings.buttonIconClass.replace(
                                "fa-",
                                ""
                              ),
                            ]}
                          />
                        </span>
                      )}
                  </span>
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initSubscribe()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initSubscribe()}
      </Draggable>
    );
  }
}

Subscribe.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Subscribe);
